import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";
import FeedbackForm from "../components/FeedbackForm";

const CPForm = () => {
  const [bgColor, setBgColor] = useState(() => {
    const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
    return isDark ? '#1e1e1e' : '#f5f5f5';
  });

  useEffect(() => {
    const updateTheme = () => {
      const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
      setBgColor(isDark ? '#1e1e1e' : '#f5f5f5');
    };

    const observer = new MutationObserver(updateTheme);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    });

    return () => observer.disconnect();
  }, []);

  return (
    <Layout>
      <div style={{ width: '100%', maxHeight: '100vh', overflow: 'auto', backgroundColor: bgColor }}>
        <FeedbackForm />
      </div>
    </Layout>
  );
};

export default CPForm;
